import { HttpClient } from '@angular/common/http';
import {inject, Injectable, signal} from '@angular/core';
import {TenantService} from './tenant.service';
import {environment} from '../../environments/environment';
import {catchError, map, of, switchMap} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TenantLogoService {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);

  private readonly defaultLogo = 'assets/images/logo.png';

  logoUrl = signal<string>(this.defaultLogo);

  loadLogo() {
    const tenant = this.tenantService.tenant;
    return this.http
      .get(`${environment.apiBaseUrl || ''}/${tenant}/files/logo`, {
        responseType: 'blob'
      })
      .pipe(
        map(blob => URL.createObjectURL(blob)),
        tap(url => this.logoUrl.set(url)),
        catchError(() => {
          this.logoUrl.set(this.defaultLogo);
          return of(this.defaultLogo);
        })
      );
  }

  uploadLogo(file: File) {
    const tenant = this.tenantService.tenant;

    const formData = new FormData();
    formData.append('file', file);

    return this.http
      .post(
        `${environment.apiBaseUrl || ''}/${tenant}/datiAziende/1/logo`,
        formData
      )
      .pipe(
        switchMap(() => this.loadLogo())
      );
  }

  resetDefault() {
    this.logoUrl.set(this.defaultLogo);
  }

  async getLogoBase64(): Promise<string | null> {
    const url = this.logoUrl();
    if (!url) return null;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  }
}
